<template>
  <div
    class="div-pccard-gestion-salida"
    @click="emitCardSelected"
  >
    <div class="seleccionable content-card">
      <div
        class="padding-left-half"
        :class="state != null ? 'content-card__title' : 'content-card__titlesecondary'"
      >
        <div
          v-if="state !== null"
          class="slot-state"
        >
          <img
            v-if="state === 0"
            alt="iconEclipseOrange"
            src="@/static/img/ic_elipse_grey.svg"
            height="10"
            width="10"
          >
          <img
            v-if="state === 1"
            alt="iconEclipseGreen"
            src="@/static/img/ic_elipse_green.svg"
            height="10"
            width="10"
          >
        </div>
        <span class="span-title"> {{ title }}</span>
        <div
          v-if="slotTitle"
          class="slot-title"
        >
          <f7-badge :class="{ 'badge-title': changeToOrange ? true : false }">
            {{ slotTitle }}
          </f7-badge>
        </div>
      </div>
      <div
        class="content-card__info padding-half"
        :class="!noAssigned ? 'content-card__info--no-assigned' : null"
      >
        <slot name="content">
          <div
            :class="state != null ? 'card-info-content-selection-left card-info-content-selection' : 'card-info-content-selection'"
          >
            <div class="card-info-content-selection__title-row">
              <div class="card-info-content-selection__title-row__left">
                <div
                  v-if="showSelectable"
                  class="card-info-content-selection__checkbox"
                >
                  <label class="checkbox">
                    <input
                      type="checkbox"
                      :checked="checked"
                      @change="
                        checked = !checked;
                        emitSelectedObject;
                      "
                    >
                    <i class="icon-checkbox" />
                  </label>
                  <span
                    v-if="noAssigned"
                    class="card-info-content-selection__checkbox__title"
                  >
                    {{ checkBoxTitle }}
                  </span>
                </div>
                <div
                  v-if="noAssigned"
                  class="card-info-content-title"
                >
                  <div class="card-info-content-title__title">
                    {{ cardTitle }}
                  </div>
                </div>
              </div>
              <div class="card-info-content-selection__title-row__right">
                <slot name="buttons">
                  <div
                    v-if="noAssigned"
                    class="title-row-buttons"
                  >
                    <div
                      v-if="showSettings"
                      class="padding-right"
                    >
                      <img
                        src="@/static/img/ic_settings_gray.svg"
                        alt="iconSettingGray"
                        width="30"
                        height="30"
                        @click="emitSettingsSelected"
                      >
                    </div>
                    <div v-if="showButtons">
                      <img
                        src="@/static/img/ic_editc.svg"
                        height="36px"
                        width="36px"
                        @click="emitEditSelected"
                      >
                      <img
                        v-if="inProduction"
                        class="img-print"
                        src="@/static/icons/ic_print-black.svg"
                        height="36px"
                        width="36px"
                        @click="emitPrintSelected"
                      >
                      <img
                        v-if="!inProduction"
                        class="img-print"
                        src="@/static/icons/ic_print-gray.svg"
                        height="36px"
                        width="36px"
                        @click="emitPrintSelected"
                      >
                    </div>
                  </div>
                </slot>
              </div>
            </div>
            <div
              v-if="noAssigned"
              class="card-info-subtitle"
            >
              <div :class="showButtons || showSettings ? 'subtitle' : 'subtitle-large'">
                {{ cardSubTitle }}
              </div>
            </div>
            <div
              v-if="noAssigned && cardText"
              class="card-info-content-text"
            >
              <span> {{ cardText }} </span>
            </div>
            <div
              v-if="!noAssigned"
              class="card-info-content-text"
            >
              <span class="display-flex justify-content-center"> {{ $t('production.common.notAssigned') }} </span>
            </div>
          </div>
        </slot>

        <slot name="footer">
          <div
            v-if="noAssigned && !footerType2"
            class="card-info-content-footer"
          >
            <div class="card-info-content-footer__ref">
              <span v-if="footerItemRef">
                {{ `${$t('common.referenceShort').toUpperCase()} ${formatText(footerItemRef, 30)}` }}
              </span>
              <span v-if="footerItemLot">
                {{ `${$t('production.common.currentLot')} ${formatText(footerItemLot, 30)}` }}
              </span>
              <slot name="footer-complement" />
            </div>
            <div
              class="card-info-content-footer__items"
              :class="{ 'card-info-content-footer__items--red': changeToRed ? true : false }"
            >
              <div v-if="itemNumberPalets">
                <span>{{ numberPalets }}</span>
                <img
                  width="26px"
                  alt="iconPale"
                  src="@/static/icons/ic_palet.svg"
                >
              </div>
              <div v-if="itemNumberPackages">
                <span>{{ numberPackages }}</span>
                <img
                  width="26px"
                  alt="iconBox"
                  src="@/static/icons/ic_box.svg"
                >
              </div>
            </div>
          </div>
          <div v-else>
            <f7-row
              v-if="arrayFooter != null"
              class="row-indicadoresPedido"
            >
              <f7-col
                v-for="(item, i) in arrayFooter"
                :key="i"
                width="20"
                class="col-rectanguloIndicadorDePedido"
              >
                <span class="span-valorInidicadorDePedido">
                  {{ item }}
                </span>
                <span class="span-texto-gris-12-400">
                  {{ i }}
                </span>
              </f7-col>
            </f7-row>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import SoporteCadena from '@/js/common/HiChainSupport';
import { ref, watch } from 'vue';

const props = defineProps({
  state: { type: Number, default: null },
  title: { type: String, default: '' },
  slotTitle: { type: String, default: '' },
  checkBoxTitle: { type: String, default: '' },
  cardTitle: { type: String, default: '' },
  cardSubTitle: { type: String, default: '' },
  cardText: { type: String, default: '' },
  showSettings: { type: Boolean, default: false },
  showButtons: { type: Boolean, default: false },
  showSelectable: { type: Boolean, default: false },
  footerItemRef: { type: String, default: '' },
  footerItemLot: { type: String, default: '' },
  footerType2: { type: Boolean, default: false },
  numberPalets: { type: String, default: '' },
  numberPackages: { type: String, default: '' },
  objectCard: { type: Object, default: null },
  arrayFooter: { type: Object, default: null },
  noAssigned: { type: Boolean, default: true },
  inProduction: { type: Boolean, default: false },
  itemNumberPalets: { type: Boolean, default: true },
  itemNumberPackages: { type: Boolean, default: true },
  changeToRed: { type: Boolean, default: false },
  changeToOrange: { type: Boolean, default: false },
  checkBoxChecked: { type: Boolean, default: false },
});

const emit = defineEmits([
  'card-selected',
  'settings-selected',
  'edit-selected',
  'print-selected',
  'selected-object',
]);

const checked = ref(false);

watch(() => props.checkBoxChecked, (val) => {
  checked.value = val;
}, { immediate: true });

/**
 * @param {string} text
 * @param {number} maxLength
 * @returns {string}
 */
function formatText(text, maxLength) {
  return text
    ? SoporteCadena.TextoLogitudMaxima(text, maxLength)
    : '';
}

function emitCardSelected() {
  emit('card-selected');
}

function emitSettingsSelected() {
  emit('settings-selected');
}

function emitEditSelected() {
  emit('edit-selected');
}

function emitPrintSelected() {
  emit('print-selected');
}

function emitSelectedObject() {
  const updatedObjectCard = { ...props.objectCard };
  updatedObjectCard.Seleccionada = checked.value;

  emit('selected-object', updatedObjectCard);
}
</script>

<style lang="scss">
.card-info-content-footer__items--red {
  span {
    -webkit-text-fill-color: var(--his-tomate-dark);
  }
}

.badge-title {
  background-color: orange;
}

.div-pccard-gestion-salida {
  margin-top: 5px;

  .content-card {
    &__title {
      background-color: #f0f8ff;
      border-radius: 6px 6px 0 0;
      justify-content: flex-start;
      align-items: center;
      display: flex;

      span {
        padding: 5px 0;
        color: var(--his-steel-blue);
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }

    &__titlesecondary {
      color: var(--his-whispering-lilac);
      background-color: var(--his-steel-blue);
      border-radius: 6px 6px 0 0;
      justify-content: space-between;
      align-items: center;
      display: flex;
    }

    .span-title {
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      font-size: 13px;
    }

    .slot-title {
      display: flex;
      justify-content: flex-end;
      margin: 5px 8px;
      --f7-badge-text-color: var(--his-whispering-lilac);
      --f7-badge-bg-color: var(--his-oliva);
      --f7-badge-font-weight: 500;
      --f7-badge-font-size: 12px;
      --f7-badge-size: 23px;
      --f7-badge-padding: 0 6px;
    }

    &__info {
      background-color: #fff;
      border-radius: 0 0 6px 6px;
      min-height: 120px; // TODO - ponerlo del mismo tamaño que la tarjeta rellena

      .row-indicadoresPedido {
        margin-top: 10px;
        margin-right: 10px;
        margin-left: 10px;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;

        .col-rectanguloIndicadorDePedido {
          background-color: rgb(247 248 250);
          width: 55px;
          height: 60px;
          display: grid;
          padding-top: 12px;
          padding-left: 2px;
          padding-right: 2px;
          padding-bottom: 1px;
          text-align: center;
          border-radius: 10px;

          .span-valorInidicadorDePedido {
            color: var(--his-darkgray);
            font-size: 20px;
            font-weight: 500;
            line-height: 26px;
            text-align: center;
          }
        }
      }

      .card-info-content-selection {
        align-items: center;
        justify-content: space-between;
        width: 100%;
        color: var(--his-navy-night);
        font-weight: 600;
        font-size: 14px;

        &__title-row {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          .title-row-buttons > div {
            display: flex;

            img:first-child {
              margin: 0 8px;
            }
          }
        }

        &__checkbox {
          display: flex;
          --f7-checkbox-border-radius: 2px;

          &__title {
            margin: 0 0 0 10px;
            color: #253858;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }
      }

      .card-info-content-title {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &__title {
          color: var(--his-navy-night);
          font-weight: 600;
          font-size: 16px;
          margin-left: 28px;
          margin-top: 5px;
        }
      }

      .card-info-subtitle {
        padding-top: 5px;
        margin-left: 28px;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;

        .subtitle-large {
          // width: 23vw;
          font-weight: 500;
          color: var(--his-ash-gray);
          font-size: 14px;
        }

        .subtitle {
          // width: 19vw;
          font-weight: 500;
          color: var(--his-ash-gray);
          font-size: 14px;
        }
      }

      .card-info-content-text {
        margin-left: 2vw;
        color: rgb(37 56 88);
        font-size: 14px;
        font-weight: 400;
      }

      .card-info-content-footer {
        display: flex;
        align-items: center;
        margin-top: 5px;
        justify-content: space-between;
        padding-left: 18px;

        &__ref {
          color: var(--his-plum-shadow);
          font-size: 13px;
          font-weight: 600;
          display: flex;
        }

        &__items {
          display: flex;
          justify-content: flex-end;

          > div {
            &:nth-child(2) {
              margin-left: 16px;
            }

            span {
              color: var(--his-steel-blue);
              font-size: 16px;
              font-weight: 600;
              margin-right: 10px;
            }
          }
        }
      }

      .card-info-content-selection-left {
        .card-info-content-title {
          &__title {
            margin-left: 18px;
            font-size: 14px;
          }
        }

        .card-info-subtitle {
          margin-left: 18px;
          margin-top: 0;

          >div {
            font-size: 13px;
          }
        }

        .card-info-content-footer {
          &__ref {
            margin-left: 18px;
          }
        }
      }

      &--no-assigned {
        box-sizing: content-box;
        min-height: 141px;
      }
    }
  }
}
</style>
